/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SkillLevelsCounts } from '../model/skillLevelsCounts';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioChildSkillStatsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * GET /child/&lt;child_id&gt;/skill-stats/?&amp;area_id&#x3D;&amp;subarea_id&#x3D; Vrací L1/L2/L3: hot/sledované/zbývá (bez summary).
     * @param childUuid 
     * @param areaId 
     * @param subareaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioChildSkillStatsRetrieve(childUuid: string, areaId?: string, subareaId?: string, observe?: 'body', reportProgress?: boolean): Observable<SkillLevelsCounts>;
    public childPortfolioChildSkillStatsRetrieve(childUuid: string, areaId?: string, subareaId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SkillLevelsCounts>>;
    public childPortfolioChildSkillStatsRetrieve(childUuid: string, areaId?: string, subareaId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SkillLevelsCounts>>;
    public childPortfolioChildSkillStatsRetrieve(childUuid: string, areaId?: string, subareaId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling childPortfolioChildSkillStatsRetrieve.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (areaId !== undefined && areaId !== null) {
            queryParameters = queryParameters.set('area_id', <any>areaId);
        }
        if (subareaId !== undefined && subareaId !== null) {
            queryParameters = queryParameters.set('subarea_id', <any>subareaId);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SkillLevelsCounts>('get',`${this.basePath}/child-portfolio/child/${encodeURIComponent(String(childUuid))}/skill-stats/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
